<template lang="pug">
  div.frame(:style="{width : width + 'px', height : height + 'px'}",:class="{ alert: alert }")
</template>

<script>
export default {
  name: 'Space',
  data () {
    return {
      width: 844,
      height: 528
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      if (this.sets[this.number] !== undefined) {
        this.set = this.sets[this.number];
        this.width = this.c2p(this.sets[this.number].space[2]);
        this.height = this.c2p(this.sets[this.number].space[1]);
        if (this.set.alert) {
          this.alert = true;
        } else {
          this.alert = false;
        }
      }
    }
  },
  created () {
    this.update();
  }
};
</script>
<style lang="stylus" scoped>
  .frame
    position absolute
    left 0
    bottom 0
    background #ffffff url("../../assets/bg_grid.svg") 0 bottom
    &:before
      content ""
      position absolute
      display block
      left 0
      right 0
      top 0
      bottom 0
      border 2px dashed #bbbbbb
    &.alert:before
      border-color #cc0000
</style>



// WEBPACK FOOTER //
// src/components/side/Space.vue